import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.82 24" {...props}><path data-name="Path 3093" d="M0 12L12 0l2.82 2.82L5.66 12l9.16 9.18L12 24z" fill="#1791dd" /></svg>);